var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniSchool02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.746094,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#D38D8D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_500_12894",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.746094,
    y: 0.710938,
    width: 258,
    height: 252,
    fill: "#D6895E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_500_12894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8086 57.9512C89.8086 55.742 91.5995 53.9512 93.8086 53.9512H269.057C271.266 53.9512 273.057 55.742 273.057 57.9512V185.998H89.8086V57.9512Z",
    fill: "#112D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8926 66.0352C97.8926 63.826 99.6834 62.0352 101.893 62.0352H260.972C263.181 62.0352 264.972 63.826 264.972 66.0352V183.302H97.8926V66.0352Z",
    fill: "#357280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.814 173.341V163.814H230.209C232.426 163.814 233.512 165.143 233.512 166.907C233.512 168.663 232.42 169.999 230.209 169.999H228.262V173.341H226.814ZM228.262 168.762H230.065C231.466 168.769 232.051 167.979 232.051 166.907C232.051 165.828 231.466 165.058 230.065 165.051H228.262V168.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.394 173.433C234.881 173.427 234.453 173.012 234.459 172.499C234.453 171.986 234.881 171.565 235.394 171.565C235.9 171.565 236.321 171.986 236.328 172.499C236.321 173.012 235.9 173.427 235.394 173.433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.144 173.341V163.814H241.539C243.756 163.814 244.841 165.143 244.841 166.907C244.841 168.663 243.749 169.999 241.539 169.999H239.591V173.341H238.144ZM239.591 168.762H241.394C242.795 168.769 243.381 167.979 243.381 166.907C243.381 165.828 242.795 165.058 241.394 165.051H239.591V168.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.657 163.814V173.341H246.249V163.814H247.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.447 173.486C250.342 173.486 249.045 172.032 249.052 169.815C249.045 167.617 250.361 166.104 252.355 166.104C253.98 166.104 255.526 167.111 255.526 169.696V170.196H250.447C250.486 171.558 251.289 172.328 252.46 172.328C253.256 172.328 253.776 171.986 254.013 171.552H255.434C255.118 172.709 254.019 173.486 252.447 173.486ZM250.453 169.144H254.144C254.144 168.058 253.44 167.255 252.368 167.262C251.243 167.255 250.513 168.137 250.453 169.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.1133,
    y: 183.303,
    width: 188.638,
    height: 16.1689,
    rx: 4,
    fill: "#112D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1133 187.303C87.1133 185.094 88.9041 183.303 91.1133 183.303H271.751C273.96 183.303 275.751 185.094 275.751 187.303V188.692H87.1133V187.303Z",
    fill: "#3E98A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.973 183.302V66.0352C264.973 63.826 263.182 62.0352 260.973 62.0352H106.516L251.744 183.302H264.973Z",
    fill: "#1D4953",
    fillOpacity: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.414 242.711V222.914H190.18C194.678 222.914 197.262 225.689 197.262 229.586C197.262 233.537 194.637 236.258 190.07 236.258H186.516V242.711H182.414ZM186.516 232.949H189.414C191.848 232.949 193.037 231.582 193.023 229.586C193.037 227.617 191.848 226.291 189.414 226.277H186.516V232.949ZM201.227 242.957C199.941 242.957 198.902 241.932 198.93 240.66C198.902 239.402 199.941 238.377 201.227 238.391C202.443 238.377 203.496 239.402 203.496 240.66C203.496 241.932 202.443 242.957 201.227 242.957ZM206.832 242.711V222.914H214.598C219.096 222.914 221.68 225.689 221.68 229.586C221.68 233.537 219.055 236.258 214.488 236.258H210.934V242.711H206.832ZM210.934 232.949H213.832C216.266 232.949 217.455 231.582 217.441 229.586C217.455 227.617 216.266 226.291 213.832 226.277H210.934V232.949ZM228.242 222.914V242.711H224.195V222.914H228.242ZM238.113 243.012C233.561 242.998 230.771 240.059 230.785 235.355C230.771 230.775 233.602 227.672 237.949 227.672C241.846 227.672 244.922 230.133 244.922 235.191V236.34H234.777C234.777 238.582 236.104 239.963 238.195 239.977C239.576 239.963 240.561 239.361 240.957 238.473H244.812C244.238 241.221 241.777 242.998 238.113 243.012ZM234.777 233.797H241.094C241.08 231.992 239.836 230.693 238.031 230.707C236.172 230.693 234.859 232.088 234.777 233.797Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniSchool02);
export default __webpack_public_path__ + "static/media/mini_school_02.8f0f562459501aa62d22fe3db49aa3a7.svg";
export { ForwardRef as ReactComponent };